import React from 'react'
import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'
import config from 'config'
import { logger } from 'logger'
import UnhandledError from 'components/Errors/UnhandledError'
import { incrementMetric } from 'data/metrics'
function IdentityComponent({ children }) {
  return children
}
let BugsnagErrorBoundary = null
function initErrorBoundary() {
  if (!config.bugsnagApiKey) {
    logger.warn('Bugsnag not initiated because its API key is missing')
    return IdentityComponent
  }
  try {
    if (!window.bugsnag) {
      window.bugsnag = bugsnag({
        apiKey: config.bugsnagApiKey,
        appVersion: config.appVersion,
        autoCaptureSessions: true,
        maxBreadcrumbs: 40,
        consoleBreadcrumbsEnabled: false,
      })
      window.bugsnag.use(bugsnagReact, React)
    }
    return window.bugsnag.getPlugin('react')
  } catch (error) {
    logger.error('Bugsnag error while initiating', error)
    return IdentityComponent
  }
}
export default function ErrorBoundary({ noCrashScreen, children }) {
  if (!BugsnagErrorBoundary) {
    BugsnagErrorBoundary = initErrorBoundary()
  }
  return (
    <BugsnagErrorBoundary
      beforeSend={report => {
        incrementMetric({ name: 'crash', service: 'app' })
        report.errorClass = noCrashScreen ? report.errorClass : 'AppCrash'
      }}
      FallbackComponent={noCrashScreen ? null : UnhandledError}
    >
      {children}
    </BugsnagErrorBoundary>
  )
}
